import { createSlice } from "@reduxjs/toolkit";
import { IOrderCostDetails } from "store/api/types";

interface OrderCostState {
  costDetails: IOrderCostDetails;
}

const initialData = {
  ["dispatching_order_uid"]: "",
  ["order_cost"]: "",
  ["add_cost"]: 0,
  ["recommended_add_cost"]: 0,
  currency: "",
  ["discount_trip"]: false,
  ["can_pay_bonuses"]: false,
  ["can_pay_cashless"]: false,
};

const initialState: OrderCostState = {
  costDetails: initialData,
};

export const orderCostSlice = createSlice({
  name: "orderCost",
  initialState,
  reducers: {
    setCostDetails: (state, { payload }) => {
      state.costDetails = payload;
    },
    setCost: (state, { payload }) => {
      state.costDetails = { ...state.costDetails, ["order_cost"]: payload };
    },
    setAddCost: (state, { payload }) => {
      state.costDetails = { ...state.costDetails, ["add_cost"]: payload };
    },
    removeCost: (state) => {
      state.costDetails = initialData;
    },
    removeAddCost: (state) => {
      state.costDetails = { ...state.costDetails, ["add_cost"]: 0 };
    },
  },
});

export const {
  setCostDetails,
  setCost,
  setAddCost,
  removeCost,
  removeAddCost,
} = orderCostSlice.actions;
export default orderCostSlice.reducer;
